import { useQuery } from '@apollo/client';
import { UserContext } from '@providers/userContextProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { FETCH_ENTITY_NAME } from './entityBreadcrumb.query';

export function EntityBreadcrumb() {
  const { t } = useTranslation();
  const { userId: paramsUserId } = useParams();
  const { activeEntity } = useContext(UserContext);
  const userId = paramsUserId ?? activeEntity?.id;
  const { data, loading } = useQuery(FETCH_ENTITY_NAME, {
    variables: { userId },
  });

  if (loading) return '';

  return data?.fetchUser?.user.entityName ?? t('client:entity');
}
